<div class="px-3 pb-3">
  <button
    type="button"
    class="btn btn-primary text-xs w-100 rounded-3 py-2 d-none"
    @click="redirect_to_proba"
  >
    Redirect to Proba
  </button>
</div>
